import React,{ useEffect, useState } from 'react';

const TypingText = ({ text }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const typingSpeed = 20; // Reduced from 100ms to 20ms (5x faster)

    const typingInterval = setInterval(() => {
      setCurrentIndex(prevIndex => prevIndex + 1);
    }, typingSpeed);

    return () => clearInterval(typingInterval);
  }, []);

  useEffect(() => {
    const processedText = text.slice(0, currentIndex);
    setDisplayText(processedText);
  }, [text, currentIndex]);

  const lines = displayText.split('\n'); 

  return (
    <div id="message" style={{ textAlign: 'left' }}>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index !== lines.length - 1 && <br />} {/* Render line break if not the last line */}
        </React.Fragment>
      ))}
    </div>
  );
};

export default TypingText;